


















































































































import { Component, Mixins } from "vue-property-decorator";
import GameMixin, { GameInterface } from "@/components/GameMixins.vue";
import ItemSelection, { item } from "@/components/shared/ItemSelection.vue";
import Undo from "@/components/shared/Undo.vue";
import Difficulty from "@/components/shared/Difficulty.vue";
import {
  edge,
  graph,
  alphabet,
  checkValidity,
  mushroomTrip,
  getMushCount,
  getResultEdges,
} from "@/components/paths/Graph";


@Component<Timed>({
  components: {
    ItemSelection,
    Undo,
    Difficulty,
  },
})
export default class Timed extends Mixins(GameMixin) implements GameInterface {
  showSol = false;  
  g: graph = {nVertices:0, nEdges:0, edges:[]};
  origin: number = null;
  mushrooms: number[] = null;
  adj: number[][] = null;
  oVertex: string;
  time: number = null;
  timeLimit: number = null;
  tries = 0;
  currentDifficultyLevel = 1;
  resultEdges: number[] = null;
  mushLimit: number = null;
  nE = this.edgeNumber(this.currentDifficultyLevel);
  difficultyLevels = 3;
  collectible = 0;
  solutionWord = "anzeigen";

  edgeNumber(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 12;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 28;
      }
      default: {
        return 12;
      }
    }
  }

  limit(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 20;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 20;
      }
      default: {
        return 100;
      }
    }
  }

  mushrooms1 = [0, 1, 2, 4, 3, 3, 5, 1];
  mushrooms2 = [3, 0, 1, 4, 3, 4, 2, 3, 1, 3, 1, 5];
  mushrooms3 = [3, 0, 1, 4, 3, 4, 2, 3, 1, 3, 0, 0, 5, 1, 2, 1];

  matrix1 = [[0, 1], [0, 4], [1, 2], [1, 3], [2, 3], [2, 5], [3, 4], [3, 5], [3, 6], [4, 7], [5, 6], [6, 7]];
  matrix2 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 5], [2, 6], [3, 6], [3, 7], [4, 5], [4, 8], [5, 8], [5, 9], [6, 7], [6, 9], [7, 10], [8, 11], [9, 10], [9, 11], [10, 11]];
  matrix3 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 3], [2, 5], [3, 6], [3, 7], [4, 5], [4, 8], [5, 6], [5, 8], [5, 9], [6, 7], [7, 9], [7, 10], [8, 11], [8, 12], [9, 12], [9, 13], [10, 13], [10, 14], [10, 15], [11, 13], [11, 14], [11, 15], [13, 14]];

  adj1 = [[1, 4], [0, 2, 3], [1, 3, 5], [1, 2, 4, 5, 6], [0, 3, 7], [2, 3, 6], [3, 5, 7], [4, 6]];
  adj2 = [[1, 2, 3], [0, 2, 4], [0, 1, 5, 6], [0, 6, 7], [1, 5, 8], [2, 4, 8, 9], [2, 3, 7, 9], [3, 6, 10], [4, 5, 11], [5, 6, 10, 11], [7, 9, 11], [8, 9, 10]];
  adj3 = [[1, 2, 3], [0, 2, 4], [0, 1, 3, 5], [0, 2, 6, 7], [1, 5, 8], [2, 4, 6, 8, 9], [3, 5, 7], [3, 6, 9, 10], [4, 5, 11, 12], [5, 7, 12, 13], [7, 13, 14, 15], [8, 13, 14, 15], [8, 9], [9, 10, 11, 14], [10, 11, 13], [10, 11]];



  off() {
    document.getElementById("overlay0").style.display = "none";
    document.getElementById("overlay1").style.display = "none";
    document.getElementById("overlay2").style.display = "none";
    document.getElementById("overlay3").style.display = "none";
    document.getElementById("overlay4").style.display = "none";
    document.getElementById("overlay5").style.display = "none";
    document.getElementById("overlay6").style.display = "none";
    document.getElementById("overlay7").style.display = "none";
    document.getElementById("overlay8").style.display = "none";
    document.getElementById("overlay9").style.display = "none";
    document.getElementById("overlay11").style.display = "none";
    document.getElementById("overlay12").style.display = "none";
    document.getElementById("overlay13").style.display = "none";
  }

  on(id: number) {
    document.getElementById(`overlay${id}`).style.display = "block";
    if (id == 13){
      setTimeout(() => {
        this.off();
      }, 5000);
    } else {
      setTimeout(() => {
          this.off();
      }, 3500);
    }
  }

  toggleColor(id: number){
      const index = id - 1;
      const list = document.getElementById(id.toString()).classList;
      //const list = document.getElementById(`r_${id}`).classList;
      if (list[4] == 'sel'){
        //document.getElementById(`r_${id}`).classList.remove('sel');
        document.getElementById(id.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "black"
        this.g.edges[index].selected=false;
      } else {
        //document.getElementById(`r_${id}`).classList.add('sel');
        document.getElementById(id.toString()).classList.add('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "red"
        this.g.edges[index].selected=true;
      }
  }

  changeDifficultyLevel(newLevel: number) {
    this.currentDifficultyLevel = newLevel;
    this.nE = this.edgeNumber(this.currentDifficultyLevel);
    this.start(); 
  }

  removeWeights(){
    document.getElementById(`blub`).remove();
  }
  
  showSolution(){
    for(let i = 0; i < this.resultEdges.length; i ++){
      const index = this.resultEdges[i]
      // const list = document.getElementById(i.toString()).classList;
      const list = document.getElementById(`r_${index}`).classList;
      if (list[4] == 'sel'){
        document.getElementById(`r_${index}`).classList.remove('sel');
        this.solutionWord = "anzeigen"
      } else {
        document.getElementById(`r_${index}`).classList.add('sel');
        this.solutionWord = "verstecken"
      }
    }
  }

  removeSelection(){
    for (let i = 1; i <= this.nE; i++) {
      try {
        document.getElementById(i.toString()).classList.remove('sel');
        document.getElementById(`r_${i}`).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${i}`).style.color = "black"
        this.g.edges[i-1].selected=false;
      } catch {
          console.log("not removed")
      }
    }
  }

  isInitialized(): boolean {
    return this.origin !== null;
  }

  start(){
    this.tries = 0;
    this.showSol = false;
    if(this.nE){
      this.removeSelection();
    }
    let matrix = null;
    switch (this.currentDifficultyLevel) {
      case 1: {
        this.g.nVertices=8;
        this.g.nEdges=12;
        this.g.edges;
        matrix = this.matrix1;
        this.mushrooms = this.mushrooms1;
        this.mushLimit = 14;
        this.timeLimit = 30;
        this.adj = this.adj1;
        break;
      }
      case 2: {
        this.g.nVertices=12;
        this.g.nEdges=20;
        this.g.edges;
        matrix = this.matrix2;
        this.mushrooms = this.mushrooms2;
        this.mushLimit = 20;
        this.timeLimit = 100;
        this.adj = this.adj2;
        break;
      }
      case 3: {
        this.g.nVertices=16;
        this.g.nEdges=28;
        this.g.edges;
        matrix = this.matrix3;
        this.mushrooms = this.mushrooms3;
        this.mushLimit = 22;
        this.timeLimit = 140;
        this.adj = this.adj3;
        break;
      }
      default: {
        matrix = this.matrix1;
        break;
      }
    }
    this.g.edges = [];
    for (let i = 1; i <= this.g.nEdges; i++) {
      const e: edge = {id:i, v1:matrix[i-1][0], v2:matrix[i-1][1], weight:Math.ceil(this.randomNumber(this.limit(this.currentDifficultyLevel))), selected:false};
      this.g.edges.push(e)
    }
    
    this.origin = Math.floor(this.randomNumber(this.g.nVertices));
    this.time = Math.floor(this.randomNumber(this.timeLimit)) + 20;
    this.removeSelection;
    this.oVertex = alphabet[this.origin];
  
  }

  //returns the ID numbers of the selected edges
  getSelected(): number[]{
    const sel: number[] = [];
      for (let i = 0; i < this.g.nEdges; i++){
          const index = i + 1;
          const list = document.getElementById(index.toString()).classList;
          if (list[4] == 'sel'){
            sel.push(i);
          }
      }
    return sel
  }

  undo(){
    this.removeSelection();
    this.solutionWord = "anzeigen";
  }

  proposedSolution(): number {
    let sol = 0;
    for (let i = 0; i < this.g.nEdges; i++) {
      if(this.g.edges[i].selected){
        sol = sol + this.g.edges[i].weight;
      }
    }
    return sol;
  }

  
  isCorrect() {
    
    const x = checkValidity(this.g, this.getSelected(), this.origin, this.origin);
    let check = x == 9;
    const vis: Set<number>[][] = new Array(this.time + 1);
    const res = mushroomTrip(this.g, this.adj, this.origin, this.time, this.mushrooms, vis);    
    const collected = getMushCount(this.g, this.getSelected(), this.mushrooms)
    const timeConstraint = this.proposedSolution() <= this.time;
    console.log(timeConstraint, this.proposedSolution(), this.time);
    
    if (!check || !timeConstraint) {
      this.on(x);
    } else {this.off();}
    this.collectible = res.pop();

    if (!timeConstraint){
      check = false;
    }

    if(!(collected == this.collectible) && check){
      check = false;
      this.tries++;
      console.log(x);
      if (this.tries < 3){
        this.on((10 + this.tries));
      } else {
        this.on(13);
      }
    }

    if(this.tries >= 3){
      this.showSol = true;
    }

    this.resultEdges = getResultEdges(this.g, res);
    const sol: boolean[] = [];
    sol.push((this.collectible == collected));
    sol.push((check));
    return sol;
  }
  
  
}


